<template>
  <div class="cardlist-container">
    <div><img :src="banner" alt="" width="100%"></div>
    <div class="drBox">
      <a href="./ExcelDemo.xlsx" style="font-size:14px; margin-right:20px;" download="demo">下载模板</a>
      <!-- <el-upload
        style="display:inline-block;"
        class="upload-demo"
        ref="upload"
        action
        :limit="1"
        :file-list="fileList"
        :before-upload="beforeUpload">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">确认导入</el-button>
      </el-upload> -->
      <span class="upExBtn">
        <input type="file" ref="upload" @change="upExHandler" value="浏览"/>
        浏览
      </span>
      <span style="font-size:12px;">{{fileName}}</span>
      <input type="button" class="upExBtn" @click="submitUpload" value="确认导入"/>
      <a :href="errorEx" style="font-size:14px;" download="Error" v-if="errorEx!==''">未成功数据点击下载详情</a>
    </div>
    <div class="box">
      <div class="title">
        <h3>展商证列表 </h3>
        <span @click="backfn">返回</span>
      </div>
      <div class="cardList">
        <div class="cardItem" v-for="(item, index) in cardList" :key="index">
          <span>{{item.tktName}}</span>
          <div class="btn" v-if="!item.tktIfTreat"><span class="xiugai" @click="xiugaiList(item.tktID)">修改</span><span class="delete" @click="deleteList(item.tktID)">删除</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api'
import axios from 'axios'
import { getItem } from '@/utils/storage'
export default {
  name: 'addCard',
  props: {},
  data () {
    return {
      ExhID: this.$store.state.EXHID,
      cardList: [],
      color: {
        'background-color': '#ffefef'
      },
      banner: require('../../assets/banner.png'),
      fileList: [],
      fileName: '',
      errorEx: '',
      files: {}
    }
  },
  computed: {
  },
  watch: {},
  created () {
  },
  mounted () {
    this.ticketlist()
  },
  methods: {
    upExHandler () {
      this.files = this.$refs.upload.files[0]
      const extension = this.$refs.upload.files[0].name.split('.')[1] === 'xls'
      const extension2 = this.$refs.upload.files[0].name.split('.')[1] === 'xlsx'
      const isLt2M = this.$refs.upload.files[0].size / 1024 / 1024 < 2
      if (!extension && !extension2) {
        alert('上传文件只能是 xls、xlsx格式!')
        return
      }
      if (!isLt2M) {
        alert('上传文件大小不能超过 2MB!')
        return
      }
      this.fileName = this.$refs.upload.files[0].name
    },
    backfn(){
       window.history.go(-1)
    },
    submitUpload () { // 确认上传
      if (this.fileName === '') {
        alert('请选择要上传的文件！')
        return false
      }
      const fileFormData = new FormData()
      fileFormData.append('files', this.files)
      const instance = axios.create({
        withCredentials: true
      })
      instance.post('https://serv.exporegist.com/selfNewapi/api/v1.0/ticket/hsbatchticketimport?ExhID=3319', fileFormData, { headers: { token: getItem('token'), 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.code === 200) {
            alert(response.data.msg)
            this.errorEx = response.data.data
            this.ticketlist()
            this.$refs.upload.value = ''
            this.fileName = ''
          } else {
            this.$refs.upload.value = ''
            this.fileName = ''
            alert(response.data.msg)
          }
        })
        .catch((error) => {
          alert(error)
        })
    },
    handleClose () {
      this.fileName = ''
    },
    ticketlist () {
      api.ticketlist({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          this.cardList = res.data.data
          // for (const item of res.data.data) {
          //   console.log(item.tktIfTreat)
          //   if (item.tktIfTreat === true) {
          //     console.log(1111)
          //     this.isShow = false
          //   } else {
          //     console.log(2222)
          //     this.isShow = true
          //   }
          // }
        } else {
          this.$router.push('/')
        }
      })
    },
    xiugaiList (tktID) {
      sessionStorage.setItem('tktID', tktID)
      this.$router.push({ path: '/addCard', query: { type: 'edit' } })
    },
    deleteList (tktID) {
      this.$confirm('请确认是否删除证件 delete or not?', '提示 notice', {
        confirmButtonText: '是Yes',
        cancelButtonText: '否No',
        type: 'warning'
      })
        .then(() => {
          api.deleteticket({
            exhId: this.ExhID,
            tktID: tktID.toString()
          }).then(res => {
            if (res.data.code === 200) {
              this.ticketlist()
            } else {
              this.$router.push('/')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="less">
.cardlist-container{
  .box {
    width: 100%;
    margin: 0 auto;
    min-height: 18rem;
  }
  .banner {
      width: 100%;
      margin: 0 auto;
      box-shadow: 0px 5px 10px 0px #f4f4f4;
  }
  .banner > img {
      width: 100%;
      margin: 0 auto;
  }
  .title{
    display: flex;
    justify-content: space-between;
    background: #f0f0f0;
    align-items: center;
    padding:0 0.3rem;
    h3{
      font-size: 0.48rem;
      padding: 0.3rem 0;
      font-weight: bold;
      color:#000000;
    }
    span{
      color:#f37a93
    }
  }
  .cardList{
    width: 100%;
    margin-bottom: 50px;
    margin: 0 auto;
    margin-top: 50px;
    border-radius: 0.3rem;
    font-size: .43rem;
    padding:24px;
    box-sizing: border-box;
  }
  .cardList .cardItem{
    line-height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #cbcbcb;
    color:#424242;
    font-size:0.43rem;
  }
  .cardList .cardItem:last-child{
    border: 0;
  }
  .cardList li font{
    color:#969696;
  }
  .btn{
  text-align: right;
  line-height: 100px;
    span{
      padding:0 40px;
      height: 48px;
      line-height: 48px;
      border-radius: 24px;
      cursor: pointer;
      display: inline-block;
      font-size:0.3rem;
    }
  }
  .xiugai{
    color: #fff;
    background: url('../../assets/bg2.png') no-repeat center center;
    background-size: 100% 100%;
  }
  .delete{
    color: #fff;
    margin-left: 100px;
    cursor: pointer;
    background: #a0a0a0;
    margin-left:20px;
  }
  .cardlist-container{
    padding-bottom: 1.2rem;
  }
  .drBox{
    padding: 20px 0;
    text-align:right;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: baseline;
    display: none;
  }
  .upExBtn{
    position:relative;
    font-size:14px;
    padding: 0px 20px;
    height: 34px;
    line-height: 34px;
    border-radius: 18px;
    color:#fff;
    background: url('../../assets/btnbg.png') no-repeat center center;
    background-size: 100% 100%;
    border:0;
    outline: none;
    margin:0 10px;
    display: inline-block;
    >input{
      position:absolute;
      top:0;
      left:0;
      height:100%;
      font-size:14px;
      line-height:100%;
      opacity:0;
      width:100%;
    }
  }
}
@media (min-width: 537px){
  .cardlist-container .title h3{
    font-size: 16px;
    padding: 8px 0;
  }
  .cardlist-container .title span{
    font-size: 14px;
  }
  .cardlist-container .cardList{
    margin-top: 20px;
  }
  .cardlist-container .cardList .cardItem{
    font-size: 14px;
    line-height: 20px;
  }
  .cardlist-container .btn span{
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
  }
  .cardlist-container .cardList .cardItem .btn{
    line-height: 60px;
  }
  .cardlist-container .drBox{
    display: block;
  }
  .el-message-box__message p{
    font-size: 14px;
  }
}
</style>
